import React, { useEffect, useState } from "react";
import Hadear from "./layout/Hadear";
import Footer from "./layout/Footer";
import { Outlet } from "react-router-dom";

const MainLayOut = () => {
  const [containerClass, setContainerClass] = useState("container");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 2000) {
        setContainerClass(""); // wide screen → fluid
      } else {
        setContainerClass("container"); // normal container
      }
    };

    handleResize(); // run on first render
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className={containerClass}>
      <Hadear />
      <Outlet />
      <Footer />
    </div>
  );
};

export default MainLayOut;
